import React from 'react'
import styled from '@emotion/styled'

const Svg = styled('svg')`
    fill: transparent;
`

type Props = {
    title?: string
    className?: string
}

const HideListIcon = ({ title, className }: Props) => (
    <Svg
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}>
        <title id="hide-list-icon">{title}</title>
        <path
            d="M1 10.5L9.9955 1.5L19 10.5"
            strokeWidth="1.75"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Svg>
)

export default HideListIcon
